module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_0@3x.51f0937a.png";